import React from "react";
import { Modal } from "react-bootstrap";
import Lottie from "lottie-react";
import animationAccept from "../../../../lottie/accept-lottie/Accept_Lottie.json";
import "./Add_Money_Modal.css";

const Add_Money_Modal = ({ showAddMoney, handleAddMoneyClose }) => {
  return (
    <Modal
      show={showAddMoney}
      onHide={handleAddMoneyClose}
      centered
      className="add-money-success-modal"
    >
      <Modal.Body className="p-0">
        <div className="modal-card-container">
          <div className="success-circle-icon">
            <Lottie animationData={animationAccept} loop={true} />
          </div>
          <div className="success-content">
            <h5 className="success-text">Amount added successfully</h5>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default Add_Money_Modal;
